import { Link, useParams } from "react-router-dom";
import { ShellTopBar } from "../shell/ShellTopBar";
import {
  PLATFORM_LEGAL_DOCS,
  PLATFORM_LEGAL_TITLES,
  isPlatformLegalSlug,
} from "./platformLegalContent";
import "./LegalDocPage.css";

/** 平台站法规页：白底黑字，文章标题 / 段落标题 / 正文 */
export default function LegalDocPage() {
  const { slug = "" } = useParams<{ slug: string }>();
  const known = isPlatformLegalSlug(slug);
  const title = known ? PLATFORM_LEGAL_TITLES[slug] : "文档";
  const doc = known ? PLATFORM_LEGAL_DOCS[slug] : null;

  return (
    <div className="legal-doc-layout">
      <ShellTopBar />
      <div className="legal-doc-page">
        <p className="legal-doc-back">
          <Link to="/">返回首页</Link>
        </p>
        <h1 className="legal-doc-h1">{title}</h1>
        {doc ? (
          <article className="legal-doc-article">
            <p className="legal-doc-p">更新日期：{doc.updatedAt}</p>
            {doc.preamble?.map((paragraph) => (
              <p key={paragraph} className="legal-doc-p">
                {paragraph}
              </p>
            ))}
            {doc.sections.map((section) => (
              <section key={section.heading} className="legal-doc-section">
                <h2 className="legal-doc-h2">{section.heading}</h2>
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph} className="legal-doc-p">
                    {paragraph}
                  </p>
                ))}
              </section>
            ))}
          </article>
        ) : (
          <p className="legal-doc-p">文档不存在。</p>
        )}
      </div>
    </div>
  );
}
